






















// Composition
import { defineComponent } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Store
import { useSearchStore } from '@/store/search'

// Components
import Sorting from '@/components/feature/search/nav/Sorting.vue'
import SearchPagination from '@/components/feature/search/nav/SearchPagination.vue'

export default defineComponent({
  components: {
    Sorting,
    SearchPagination,
  },

  props: {
    showSorting: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    const searchStore = useSearchStore()
    const { getResults, isProductTab } = storeToRefs(searchStore)

    return {
      getResults,
      toggleShowMobileFacets: searchStore.toggleShowMobileFacets,
      isProductTab,
    }
  },
})
